<template>
  <div class="plateno-container">
    <div class="p3-container">
      <div class="blue-block"></div>
      <div class="blue-block2"></div>
      <p class="top-font">请输入车牌号码</p>
      <div id="addCarInput" style="padding-left: 12px; padding-right: 12px">
        <div class="inputList" :class="cardType === 3 ? 'white-card' : ''">
          <template v-for="(input, index) in inputList">
            <input
              type="text"
              readonly
              @focus="
                (e) => {
                  show(e, index);
                }
              "
              @change="updateCarnum()"
              class="input-sty"
              :class="inputInx == index ? 'focus' : ''"
              maxlength="1"
              :data-keyset="keySet(input.keyset)"
              :data-layout="input.layout"
              :data-spkeyset="input.spKeySet"
              :key="index"
              :placeholder="index == 7 ? '新能源' : ''"
            />
          </template>
        </div>
        <div class="add-container">
          <van-button
            type="primary"
            size="large"
            color="#4182F4"
            round
            :disabled="addBtnActive"
            @click="submitCarnum()"
            style="font-size:18px"
            >查询缴费</van-button
          >
        </div>
        <transition name="">
          <key-board
            id="key-board"
            v-if="isKeyBoardShow"
            :input="inputEl"
            :close="close"
            :next="next"
            :currentKeySet="keyset"
            :spKeySet="spKeySet"
            :previous="previous"
            :updateValue="updateCarnum"
            :showCancel="true"
            @cancel="isKeyBoardShow = false"
            @setKeySet="setKeySet"
            :layout="layout"
          >
          </key-board>
        </transition>
      </div>
      <!-- 历史搜索 -->
      <div class="flex-row-container">
        <van-tag
          size="medium"
          color="#ededed"
          text-color="#333333"
          closeable
          style="margin-right: 12px"
          v-for="(item, index) in historyTag"
          :key="index"
          @close="closeTag(item.id)"
          @click="submitCarnum(item.plateNo)"
          >{{ item.plateNo }}</van-tag
        >
      </div>
    </div>
  </div>
</template>
<script>
import keyBorad from '@/components/Keyborad'
import isArray from 'lodash/isArray'
import api_parking from '@/api/parking/index.js'
import { getLocal } from '@/utils/index'
import { Toast } from 'vant'
import _axios from '@/utils/service'

export default {
  name: 'addcar',
  components: {
    'key-board': keyBorad
  },
  data() {
    return {
      inputEl: null, // 当前选中input元素
      isKeyBoardShow: false, // 展示隐藏键盘标志
      layout: '', // 传递给键盘组件布局参数
      keyset: '', // 传递给键盘组件布局参数
      spKeySet: '', // 传递给键盘组件【殊】布局参数
      cardType: 2, // 0 黄，1 蓝， 2 绿, 3白, 4 黑
      carNum: ['', '', '', '', ''], // 滑动选择展示的车牌号
      inputElList: [], // 页面中所有
      input: [],
      inputInx: 0,
      input0Value: null,
      inputs: [],
      historyTag: []
    }
  },
  mounted() {
    this.inputs = document.querySelectorAll('input')
    this.getHistory()
  },
  computed: {
    /* 生成input框配置 */
    inputList: {
      get: function() {
        if (this.cardType === 2) {
          // 绿色能源车
          return [
            { layout: 'area', keyset: 'default' },
            { layout: 'area', keyset: 'abc' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' }
          ]
        } else if (this.cardType === 3) {
          //白牌
          if (this.input0Value == 'WJ') {
            // 首位为WJ时，第二位键盘只能输入省份
            return [
              { layout: 'area', keyset: 'defaultOn' },
              { layout: 'area', keyset: 'default' },
              { layout: 'area', keyset: 'num' },
              { layout: 'area', keyset: 'num' },
              { layout: 'area', keyset: 'num' },
              { layout: 'area', keyset: 'num' },
              { layout: 'area', keyset: 'num', spKeySet: 'YJ' }
            ]
          }
          return [
            { layout: 'area', keyset: 'defaultOn' },
            { layout: 'area', keyset: 'abc' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num', spKeySet: 'YJ' }
          ]
        } else if (this.cardType === 4) {
          //黑牌
          return [
            { layout: 'area', keyset: 'default' },
            { layout: 'area', keyset: 'abc' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num', spKeySet: 'GA' }
          ]
        } else if (this.cardType === 1) {
          //蓝牌
          return [
            { layout: 'area', keyset: 'default' },
            { layout: 'area', keyset: 'abc' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' }
          ]
        } else {
          // 黄牌
          return [
            { layout: 'area', keyset: 'default' },
            { layout: 'area', keyset: 'abc' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num' },
            { layout: 'area', keyset: 'num', spKeySet: 'XUE' }
          ]
        }
      },
      set: function(newVal) {
        this.input0Value = newVal
      }
    },
    addBtnActive() {
      if (this.carNum[this.cardType].length > 7) {
        // eslint-disable-next-line
        return false;
      } else {
        // eslint-disable-next-line
        return true;
      }
    }
  },
  watch: {
    inputEl: function() {
      this.updateCarnum()
    },
    cardType: function() {
      this.updateCarnum()
    },
    inputElList: function() {
      this.updateCarnum()
    }
  },
  methods: {
    async closeTag(recordId) {
      await _axios({
        url: '/charge/v2/api/plateHistory/record',
        method: 'delete',
        params:{
          recordId
        }
      })
      this.getHistory()
    },
    setKeySet(keyset) {
      this.keyset = keyset
    },
    keySet(key) {
      let keyset = key
      if (isArray(keyset)) {
        return keyset[this.cardType]
      }
      return keyset
    },
    hide() {
      this.isKeyBoardShow = false
    },
    show(e, index) {
      document.activeElement.blur()
      this.isKeyBoardShow = true
      this.inputEl = e.target
      this.inputInx = index
      this.layout = this.inputEl.dataset.layout
      this.keyset = this.inputEl.dataset.keyset || 'default'
      this.spKeySet = this.inputEl.dataset.spkeyset || 'off'
    },
    close() {
      this.inputEl.blur()
      this.hide()
    },
    next() {
      let inputs = document.querySelectorAll('input')
      let found = false;
      [].forEach.call(inputs, (item, i) => {
        if (!found && item === this.inputEl && i < inputs.length - 1) {
          found = true
          this.$nextTick(() => {
            inputs[i + 1].focus()
          })
        }
      })
      if (!found) {
        this.inputEl.blur()
        this.inputEl = null
        this.hide()
      }
    },
    previous() {
      let inputs = document.querySelectorAll('input')
      let found = false;
      [].forEach.call(inputs, (item, i) => {
        if (!found && item == this.inputEl && i > 0) {
          found = true
          this.$nextTick(() => {
            inputs[i - 1].focus()
            inputs[i - 1].value = ''
          })
        }
      })
      if (!found) {
        this.inputEl.blur()
        this.inputEl = null
        this.hide()
      }
    },
    changeCardType(newVal) {
      this.cardType = newVal
      if (this.inputEl) {
        // 更新键盘
        this.inputEl.blur()
        this.$nextTick(() => {
          this.inputEl.focus()
        })
      }
    },
    updateCarnum() {
      this.$nextTick(() => {
        let carnum = ''
        let inputs = document.querySelectorAll('input')
        if (this.cardType !== 0 && inputs[6].value === '学') {
          // 只有黄牌最后一位能为"学"
          inputs[6].focus()
          inputs[6].value = ''
        }
        if (
          this.cardType !== 3 &&
          inputs[1].value.match(/^[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川黔滇藏陕甘青宁新]/)
        ) {
          // 白牌"省份第二位"切换车牌颜色清空
          inputs[1].focus()
          inputs[1].value = ''
        }
        if (this.cardType !== 3 && inputs[0].value.match(/^[A-Z]/)) {
          // 只有白牌能以"字母"开头
          inputs[0].focus()
          inputs[0].value = ''
        }
        if (this.cardType !== 3 && inputs[6].value.match(/^[警应急]/)) {
          // 只有白牌最后一位可以包含 '警应急'
          inputs[6].focus()
          inputs[6].value = ''
        }
        if (this.cardType !== 4 && inputs[6].value.match(/^[港澳]/)) {
          // 只有黑牌最后一位可以包含 '港澳'
          inputs[6].focus()
          inputs[6].value = ''
        }
        for (let i = 0; i < inputs.length; i++) {
          if (i === 2 && carnum.length > 1) {
            if (this.cardType === 3) {
              carnum += ' '
            } else {
              carnum += '·'
            }
          }
          carnum += inputs[i].value
        }
        this.carNum = ['', '', '', '', '']
        this.inputList = this.inputs[0].value
        this.$set(this.carNum, this.cardType, carnum)

        /* 当首位为Wj时 第二位必须输入省份 */
        this.$nextTick(() => {
          let input1 = inputs[1]
          if (this.input0Value == 'WJ' && this.inputInx == 1) {
            if (input1.value.match(/^[A-Z]/)) {
              input1.value = ''
            }
            input1.focus()
          }
        })
      })
    },
    passAddCar() {
      this.$router.push(this.$router.push(this.$route.query.path))
    },
    async getHistory() {
      let res = await _axios('/charge/v2/api/plateHistory/record')
      this.historyTag = res.data
    },
    submitCarnum(historyPlateNo = '') {
      let palteNo = this.carNum[this.cardType].replace(/[·\s]/g, '')
      if (historyPlateNo) {
        palteNo = historyPlateNo.replace(/[·\s]/g, '')
      }
      api_parking
        .plateNo({
          plateNo: palteNo,
          dealerId: getLocal('dealerId'),
          parkId: getLocal('parkId')
        })
        .then((res) => {
          if (res.data.count === 0) {
            this.getHistory()
            Toast('未查到待缴费信息')
          } else {
            this.$router.push(
              `/multiPayPage?plateNo=${palteNo}&arrearsOnly=${res.data.arrearsOnly}`
            )
          }
        })
    }
  },
  activated() {
    this.carNum = ['', '', '']
    document.querySelectorAll('input').forEach((input) => {
      input.value = ''
    })
  }
}
</script>

<style lang="less" scoped>
.plateno-container {
  padding: 0 12px;
}
.p3-container {
  position: relative;
  padding: 0 0 12px 0;
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
}
.blue-block {
  width: 100%;
  height: 16px;
  background-color: #a1c6ff;
}
.blue-block2 {
  margin: -1px auto;
  width: 40%;
  height: 16px;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url("../assets/platenobg.png");
}
.top-font {
  position: absolute;
  top: 6px;
  left: 50%;
  text-align: center;
  font-size: 14px;
  color: #333333;
  transform: translateX(-50%);
}
.flex-row-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 12px 0 12px;
}
.input-sty::placeholder{
  padding-top: 4px;
}
</style>
<style lang="less">
#addCarInput {
  .plateBg {
    height: 140px;
    /* 用于组件报错 cancelable = false */
    touch-action: none;
  }
  .inputList {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    input {
      margin-left: 5px;
      width: 36px;
      height: 40px;
      font-size: 24px;
      text-align: center;
      color: #333;
      background: rgba(65, 130, 244, 0.06);
      border: 1px solid rgba(176, 205, 255, 1);
      border-radius: 4px;
      transition: border-color ease-in-out;
      &::placeholder {
        font-size: 10px;
        transform: translateY(-4px);
      }
      &.focus {
        border-color: #4182f4;
        outline: 0;
      }
      &:first-of-type {
        position: relative;
        margin-left: 0px;
      }
      &:first-of-type::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        border: 5px solid #4182f4;
        border-left: 5px solid transparent;
        border-bottom: 5px solid transparent;
      }
      &:last-of-type {
        background: rgba(0, 208, 5, 0.06);
        border: 1px dashed rgba(26, 184, 105, 1);
      }
    }
    &.white-card input:nth-child(2) {
      margin-right: 0px;
    }
  }
  .add-container {
    margin-top: 20px;
    #addBtn {
      width: 90%;
      margin: 0 auto;
      text-align: center;
      background-color: #ddd;
      border-radius: 25px;
      height: 47px;
      line-height: 47px;
      span {
        color: #fff;
      }
      &.active {
        background: #5aa9f7;
      }
    }
    .passBtn {
      font-size: 15px;
      text-align: center;
      margin-top: 15px;
      color: #999999;
    }
  }
  #key-board {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1000;
    background-color: #e2e3e7;
    padding: 6px 5px 10px;
    // border-radius: 10px;
    // box-shadow: 0px 2px 2px #eee;
    .key {
      box-shadow: none;
      border: none;
      border-radius: 0.5em;
      height: 2.5em;
      line-height: 2.5em;
      color: #000;
      font-weight: 100;
      &.backspace {
        font-size: 1em;
      }
      &.notouch {
        background: #eee;
        color: #666;
        cursor: not-allowed;
      }
    }
    .special-line {
      overflow: hidden;
      padding: 5px 0;
      .key {
        background-color: #c4c8d0;
        color: #000;
        border-radius: 0;
        line-height: 2em;
        height: 2em;
        &:not(:last-child) {
          border-right: 1px solid #ddd;
        }
        &.notouch {
          color: #666;
        }
      }
    }
  }
  .move-enter-active {
    animation: move-in 0.5s;
  }
  .move-leave-active {
    animation: move-in 0.5s reverse;
  }
  @keyframes move-in {
    0% {
      transform: translateY(100%);
    }

    100% {
      transform: translateY(0);
    }
  }
}
</style>


